import { render, staticRenderFns } from "./NbOption.vue?vue&type=template&id=0a6272cb&scoped=true&"
import script from "./NbOption.vue?vue&type=script&lang=js&"
export * from "./NbOption.vue?vue&type=script&lang=js&"
import style0 from "./NbOption.vue?vue&type=style&index=0&id=0a6272cb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a6272cb",
  null
  
)

export default component.exports